import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GenericModalService } from '../generic-modal/generic-modal.service';
import { OeAppPersonService } from '../oe-app-person.service';
import { TranslatePipe } from '../translate.pipe';
import { TranslatorToolService } from '../translator-tool/translator-tool.service';
import { StudyBundleCourseDto } from '../types/StudyBundleCourseDto';
import { OeAppService } from '../oe-app.service';

const Events = {
  StartPractice: 'StartPractice',
  ClosePractice: 'ClosePractice',
  CompletePractice: 'CompletePractice',
  ResizeIframe: 'ResizeIframe',
};

@Component({
  selector: 'lp2-media-player',
  templateUrl: './media-player.component.html',
  styleUrls: ['./media-player.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MediaPlayerComponent implements OnInit, OnDestroy {
  @Input()
  set mediaItemValue(value: StudyBundleCourseDto) {
    this.mediaItem = value;
    this.iframeUrl =
      !!value && value.url
        ? this.sanitizer.bypassSecurityTrustResourceUrl(
            value.url +
              `&language=${this.oeAppPersonService.nativeLang}` +
              `&contentServicesUrl=${this.oeAppService.contentServicesUrl}`
          )
        : undefined;
  }

  @Input()
  width = 750;

  @Input()
  height = 600;

  @Output()
  close = new EventEmitter();

  @Output()
  destroy = new EventEmitter();

  @ViewChild('iframeRef')
  iframeRef: ElementRef;

  iframeUrl: SafeResourceUrl;

  startTime: number;

  endTime: number;

  complete = false;

  mediaItem: StudyBundleCourseDto;

  constructor(
    private sanitizer: DomSanitizer,
    private translatePipe: TranslatePipe,
    private genericModalService: GenericModalService,
    private oeAppPersonService: OeAppPersonService,
    private oeAppService: OeAppService,
    private translatorToolService: TranslatorToolService
  ) {}

  ngOnInit(): void {
    window.addEventListener('message', this.handleEvents.bind(this), false);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleEvents);
    this.destroy.emit({
      mediaItem: this.mediaItem,
      startTime: this.startTime,
      endTime: this.endTime,
      complete: this.complete,
    });
  }

  public handleEvents({ data, origin }) {
    console.log('data', data)
    const originHostname = new URL(this.mediaItem.url).hostname;
    const hostname = new URL(origin).hostname;
    console.log('hostname', hostname);
    console.log('originHostname', originHostname);
    if (hostname !== originHostname) {
      return;
    }

    const type = data.type;
    console.log('type', type)
    switch (type) {
      case Events.StartPractice:
        this.startPracticeEvent();
        break;
      case Events.ClosePractice:
        this.closePracticeEvent();
        break;
      case Events.CompletePractice:
        this.completePracticeEvent();
        break;
      case Events.ResizeIframe:
        this.resizeIframeEvent(data.value);
        break;
    }
  }

  reloadPage() {
    location.reload();
  }

  resizeIframeEvent({ height }: { height: number }) {
    if (height) {
      this.height = height;
    }
  }

  startPracticeEvent() {
    console.log('startPracticeEvent');
    this.startTime = new Date().getTime();
  }

  closePracticeEvent() {
    console.log('closePracticeEvent');
    this.endTime = new Date().getTime();
    this.close.emit();
  }

  completePracticeEvent() {
    console.log('completePracticeEvent');
    this.complete = true;
  }

  translateWordEvent(word: string, callback: any) {
    console.log('translateWordEvent', word, callback);
    this.translatorToolService.translate({ text: word, targetLang: this.oeAppPersonService.nativeLang }).subscribe(
      (data) => {
        if (callback && typeof callback === 'function') {
          callback(data);
        }
      },
      () => {
        this.genericModalService.show(
          this.translatePipe.transform('alert.titleError'),
          this.translatePipe.transform('errors.unablePerformAction')
        );
      }
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/media-player/media-player.component.ts